import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { toast } from "react-toastify";
import ConfirmModal from "../../Component/Common/ConstomModal/ConfirmModal";
import CustomPagination from "../../Component/Common/CustomPagination";
import { CustomReactTable } from "../../Component/Common/CustomReactTable";
import SwitchField from "../../Component/Common/SwitchField";
import Breadcrumbs from "../../Component/Common/Breadcrumbs";
import EditIcon from "../../../image/Group15.png";
import DeleteIcon from "../../../image/deleteIcon1.png";
import useDebounce from "../../helper/customhook";
import { FEATURES, hasAccess, getAccessLevel, ACCESS } from "../../helper";
import { getStorage } from "../../helper/storage";
import { deleteCastPro, getCastProfession, updateActiveCastPro } from "../../services/serviceCastPro";

const column = [
  { Header: "S.No", accessor: "sno" },
  { Header: "Caste English", accessor: "caste_english" },
  { Header: "Caste Hindi", accessor: "caste_hindi" },
  { Header: "Profession English", accessor: "profession_english" },
  { Header: "Profession Hindi", accessor: "profession_hindi" },
  { Header: "Assembly Number", accessor: "assembly_number" },
  { Header: "Action", accessor: "action" },
];

// Cast Management list (was CastPro.js) - Upload/Add moved to their own
// routed pages, this keeps just the table.
export const CastList = () => {
  const navigate = useNavigate();
  const userLogin = getStorage("logged-in");
  const queryClient = useQueryClient();

  const obj = { offset: 0, currentPage: 0, name: "", ordering: "-id" };
  const [filter, setFilter] = useState({ limit: 20, ...obj });
  const [loaderForList, setLoaderForList] = useState(false);
  const [openDel, setOpenDel] = useState(false);
  const [deleteId, setDeleteId] = useState("");

  const debouncedFilter = useDebounce(filter, 500);
  const { data } = useQuery(["getCastProfession", debouncedFilter], () => getCastProfession(debouncedFilter, filter), {
    enabled: Boolean(debouncedFilter),
  });

  useEffect(() => {
    setLoaderForList(!data);
  }, [data]);

  const updateActiveMutation = useMutation(updateActiveCastPro, {
    onSuccess: (res) => {
      if (res?.success) {
        toast.success(res?.message || "success");
        queryClient.refetchQueries("getCastProfession");
      }
    },
  });

  const deleteMutation = useMutation(deleteCastPro, {
    onSuccess: (res) => {
      if (res?.success) {
        toast.success(res?.message || "success");
        queryClient.refetchQueries("getCastProfession");
        setOpenDel(false);
      }
    },
  });

  const hendleDeleteTag = (data, flag) => {
    setOpenDel(flag);
    setDeleteId(data);
  };

  const handlePageClick = (data) => {
    const currentPage = data.selected;
    setFilter((s) => ({ ...s, offset: currentPage * filter.limit, currentPage }));
  };

  const rowDataList = (rows) =>
    rows?.map((item, i) => ({
      ...item,
      sno: <div>{i + 1 + filter.limit * filter.currentPage}</div>,
      action: (
        <div className="actionBtn">
          <SwitchField
            size="sm"
            onSwitchChange={() => updateActiveMutation.mutate({ id: item.uuid, is_active: !item?.is_active })}
            value={item.is_active}
            disabled={!hasAccess(userLogin?.user_type, FEATURES.CAST_PROFESSION, ACCESS.LIMITED)}
          />
          {hasAccess(userLogin?.user_type, FEATURES.CAST_PROFESSION, ACCESS.LIMITED) && (
            <img src={EditIcon} alt="" onClick={() => navigate(`/cast-management/add?editId=${item.uuid}`)} />
          )}
          {getAccessLevel(userLogin?.user_type, FEATURES.CAST_PROFESSION) === ACCESS.FULL && (
            <img src={DeleteIcon} alt="" onClick={() => hendleDeleteTag(item, true)} />
          )}
        </div>
      ),
    }));

  return (
    <>
      <div className="ques_container">
        <Breadcrumbs
          active="Cast And Profession"
          action={
            <div className="upload_button_ui">
              {/* {getAccessLevel(userLogin?.user_type, FEATURES.CAST_PROFESSION) === ACCESS.FULL && (
                <button className="addPlan" onClick={() => navigate("/cast-management/upload")}>
                  Upload
                </button>
              )}
              {hasAccess(userLogin?.user_type, FEATURES.CAST_PROFESSION, ACCESS.LIMITED) && (
                <button className="addPlan" onClick={() => navigate("/cast-management/add")}>
                  Add Cast And Profession
                </button>
              )} */}
            </div>
          }
        />

        <div>
          <div className="table-responsive">
            <CustomReactTable columns={column} data={rowDataList(data?.results ? data?.results : [])} tableLoading={loaderForList} />
          </div>
        </div>
      </div>

      {data?.results?.length > 0 && (
        <CustomPagination onPageChange={handlePageClick} currentPage={filter?.currentPage} pageCount={Math.ceil(data?.count / filter?.limit)} />
      )}

      <ConfirmModal isOpen={openDel} toggle={() => setOpenDel(!openDel)} onSubmit={() => deleteMutation.mutate(deleteId)} />
    </>
  );
};
